import { Button, ButtonProps } from '@mui/material';

export const InlineTextButton = (props: ButtonProps) => (
  <Button
    variant="text"
    {...props}
    sx={{
      padding: 0,
      minWidth: 'auto',
      verticalAlign: 'baseline',
      textTransform: 'none',
      fontSize: 'inherit',
      fontWeight: 'inherit',
      lineHeight: 'inherit',
      color: 'primary.main',
      textDecoration: 'underline',
      '&:hover': {
        backgroundColor: 'transparent',
        textDecoration: 'underline',
      },
      ...props.sx,
    }}
  />
);